import { render, staticRenderFns } from "./SeminarSetPrice.vue?vue&type=template&id=4bdc7c98&scoped=true&"
import script from "./SeminarSetPrice.vue?vue&type=script&lang=js&"
export * from "./SeminarSetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc7c98",
  null
  
)

export default component.exports